import { useCallback } from 'react';

import { MyCareerProfileDocument, useSaveCvLocaleMutation } from 'core';

type SaveCvText = [
  (language: string, jobTitle: string, about: string) => Promise<unknown>,
  {
    loading: boolean;
    success: boolean;
    errorCode?: string | null;
    errorField?: string | null;
  },
];

/**
 * Saves the per-language CV headline + about text (spec 0018 §9 — RUS/ENG/POL).
 */
export const useSaveCvText = (): SaveCvText => {
  const [mutate, { data, loading }] = useSaveCvLocaleMutation({
    refetchQueries: [{ query: MyCareerProfileDocument }],
  });

  const save = useCallback(
    (language: string, jobTitle: string, about: string) =>
      mutate({ variables: { language, jobTitle, about } }),
    [mutate],
  );

  return [
    save,
    {
      loading,
      success: Boolean(data?.saveCvText?.success),
      // Код, а не текст: серверное сообщение написано по-русски и
      // предназначено логам — на экран его класть нельзя.
      errorCode: data?.saveCvText?.customErrors?.[0]?.code ?? null,
      errorField: data?.saveCvText?.customErrors?.[0]?.field ?? null,
    },
  ];
};
